import { Injectable } from '@angular/core';

@Injectable()
export class AlertService {

  public errorAlert(mensagem: string): JQuery {
    const alerta = bootbox.alert(mensagem);
    alerta.on('shown.bs.modal', function () {
        $('button[data-bb-handler="ok"]').attr('id', 'btn-bootbox-ok');
        $('button[data-dismiss="modal"]').attr('id', 'btn-bootbox-close');
        $('div[class="bootbox-body"]').attr('id', 'div-bootbox-body');
    });
    return alerta;
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/services/alert.service.ts